import React from 'react';

import type { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import { BodyGrid, BodyList } from './body';
import type { ExclusiveItemProps } from './exclusive-item';

export interface ExclusiveListProps {
  exclusiveItemList: Record<SubscriptionTier, ExclusiveItemProps[]>;
  onClick: (offer: ExclusiveItemProps) => void;
  onShowOfferCard: (offer: ExclusiveItemProps) => void;
  processingOfferId: string | undefined;
}

export function ExclusiveList(props: Readonly<ExclusiveListProps>) {
  return (
    <div className="flex w-full flex-col gap-[12px]">
      <BodyList {...props} />
    </div>
  );
}

export function ExclusiveGrid(props: Readonly<ExclusiveListProps>) {
  return (
    <div className="flex w-full flex-col gap-[12px]">
      <BodyGrid {...props} />
    </div>
  );
}

export const ExclusiveItemCollection = (props: ExclusiveListProps) => {
  const { isMobile } = useResponsive();
  return isMobile ? <ExclusiveList {...props} /> : <ExclusiveGrid {...props} />;
};
